import HttpRequest from './axiosConfig';
import config from '@/config';

const apiRequest = new HttpRequest(config.apiBaseUrl);

export default apiRequest;
